import { useEffect } from 'react';
import AWS from 'aws-sdk';
import { v4 as uuid } from 'uuid';
import * as Sentry from '@sentry/react';

const {
  REACT_APP_AWS_ACCESS_KEY_ID,
  REACT_APP_AWS_SECRET_ACCESS_KEY,
  REACT_APP_AWS_REGION,
  REACT_APP_AWS_BUCKET_NAME,
} = process.env;

AWS.config.update({
  accessKeyId: REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: REACT_APP_AWS_REGION,
});

export const useUpload = async (file, path, setSuccess, setProgress, setResponse, setUploading) => {
  useEffect(() => {
    const uploadFile = async () => {
      const mime = file.type;
      const [, ext] = file.type.split('/');

      const key = `${path}${uuid()}.${ext}`;

      const upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: REACT_APP_AWS_BUCKET_NAME,
          Key: key,
          Body: file,
          // IMPORTANT: Ne pas définir ACL ici.
          // Le bucket a "Block public ACLs" activé, donc "public-read" provoque un 403.
        },
      });

      try {
        setUploading(true);

        upload.on('httpUploadProgress', (event) => {
          const uploaded = Math.round((event.loaded / event.total) * 100);
          setProgress(uploaded);
        });

        const { Bucket, Key } = await upload.promise();

        setSuccess(true);
        setResponse({ Bucket, Key, mime });
        setUploading(false);
      } catch (e) {
        console.log('ERROR UPLOAD', e);
        Sentry.captureException(e);
        setSuccess(false);
        setUploading(false);
      }
    };

    if (file && path) {
      uploadFile();
    }
  }, [file, path, setSuccess, setProgress, setResponse, setUploading]);
};
